// extracted by mini-css-extract-plugin
export default {"labelDesktopStyle":"TextFieldWidgetText2_labelDesktopStyle__OCqab","inputContainerStyle":"TextFieldWidgetText2_inputContainerStyle__y0--n"};